import React from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Typography,
  TableBody,
  Chip,
} from "@mui/material";
import EmptyData from "../../Common/EmptyData";
import CopyButton from "../../Common/CopyButton";

const UserProductOrder = ({ data }) => {
  return (
    <>
      {!data || data?.length === 0 ? (
        <>
          <EmptyData />
        </>
      ) : (
        <>
          <TableContainer sx={{ mt: 3 }}>
            <Table>
              <TableHead>
                <TableRow sx={{ bgcolor: "#f8f8f7" }}>
                  <TableCell>Order ID</TableCell>
                  <TableCell>Product</TableCell>
                  <TableCell>Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        columnGap: 2,
                      }}
                    >
                      <Typography
                        sx={{
                          color: "#4d4d4d",
                          fontWeight: 500,
                          width: "100px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {item?._id}
                        <Typography
                          sx={{
                            color: "#4d4d4d",
                            fontSize: "12px",
                            mt: 1,
                            fontWeight: 400,
                          }}
                        >
                          ${item?.amountPaid.toLocaleString()}
                        </Typography>
                      </Typography>
                      <CopyButton id={item?._id} />
                    </TableCell>
                    <TableCell> {item?.product?.name}</TableCell>
                    <TableCell><Chip sx={{px:3, borderRadius:'8px', fontWeight:500, 
                    ...(item?.status === "Paid" && {
                      bgcolor:'#E6F8FF', color:'#0495CA'
                    })
                    }} label={item?.status}/></TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      )}
    </>
  );
};

export default UserProductOrder;
